import React from 'react'

import { CircularProgress } from '@mui/material'
import isEmpty from 'lodash/isEmpty'

import TopicRefinementButton from 'components/TopicRefinementButton'
import TopicRefinementResponse from 'components/TopicRefinementResponse'

import useTopicRefinement from 'hooks/useTopicRefinement'

export const TEST_ID = 'TopicRefinementSection'

export type Props = {
	businessProblem: string
	companyName: string
	dataTestId?: string
}

const TopicRefinementSection = ({
	businessProblem,
	companyName,
	dataTestId = 'topic-refinement-section',
}: Props) => {
	const {
		aiResponse,
		clearResponse,
		loading: refinementLoading,
		requestRefinement,
	} = useTopicRefinement()

	return (
		<>
			<TopicRefinementButton
				promptText={businessProblem}
				onClick={() => {
					requestRefinement(businessProblem, companyName)
				}}
				dataTestId={`${dataTestId}__topic-refinement-button`}
			/>
			{refinementLoading && (
				<CircularProgress
					data-testid={`${dataTestId}__topic-refinement-loading`}
					size={24}
				/>
			)}
			{!isEmpty(aiResponse) && (
				<TopicRefinementResponse
					contentText={aiResponse}
					clearResponse={clearResponse}
					data-testid={`${dataTestId}__topic-refinement-response`}
				/>
			)}
		</>
	)
}

export default TopicRefinementSection
